// extracted by mini-css-extract-plugin
export default {"error":"LosAutocomplete_error__8F8iW","menu":"LosAutocomplete_menu__Y9JpR"};